"use strict";

define('app/document/edit/document.edit.view',['vertebrae'], function (Vertebrae) {
  var SubmissionEditView = Vertebrae.View.extend({
    templates: {
      'document.edit.init': 'renderInitFragment',
      'study.detail.pdf': 'renderDocumentPDFDetailsFragment'
    },
    render: function render() {
      this.$el.html(this.renderInitFragment());
    },
    getDocumentPDFElement: function getDocumentPDFElement(data) {
      var fragment = this.renderDocumentPDFDetailsFragment(data);
      el = $('<body></body>');
      el.append(fragment);
      return el;
    },
    getFormWrapperElement: function getFormWrapperElement() {
      return this.$('.form-wrapper');
    },
    getFormContainerElement: function getFormContainerElement() {
      return this.$('.form-container');
    }
  });
  return SubmissionEditView;
});

